import PlatformInfo from '../PlatformInfo';
import { PLATFORMS } from '../data';

export default function ProfileDxTrade() {
  return <PlatformInfo platform={PLATFORMS.dxtrade} />;
}
